import LegalShell from "@/components/LegalShell";

export default function Privacy() {
    return (
        <LegalShell title="Privacy Policy" testId="page-privacy">
            <p className="text-sm text-aq-muted">
                <strong>Last updated:</strong> 28 June 2026
            </p>

            <p>
                TheCounselCo ("we", "us", "our") operates the AcademiQ assessment and report
                service. This policy explains what information we collect, why, and how we protect
                it. By using our service, you agree to this policy.
            </p>

            <h2>Who we collect information about</h2>
            <p>
                We collect information from the parent or guardian who purchases the assessment,
                and assessment responses from the student who takes it. The student is a minor;
                the purchasing parent or guardian provides consent on their behalf.
            </p>

            <h2>What we collect</h2>
            <ul>
                <li>
                    Parent/guardian name, WhatsApp/phone number, and email address (so we can
                    deliver the report and respond to queries).
                </li>
                <li>The student's responses to the assessment questions.</li>
                <li>
                    Basic payment confirmation details from our payment processor (we do{" "}
                    <strong>not</strong> collect or store your card, UPI or bank details).
                </li>
            </ul>

            <h2>Why we collect it</h2>
            <p>
                Solely to prepare your child's personalised report, deliver it to your WhatsApp and
                email, respond to your questions, and improve our service. We do not use it for
                anything else.
            </p>

            <h2>Payments</h2>
            <p>
                Payments are processed securely by Razorpay. We never see or store your full card
                numbers, UPI PINs or banking credentials. Razorpay's handling of payment data is
                governed by Razorpay's own privacy policy.
            </p>

            <h2>How we protect your information</h2>
            <p>
                We take reasonable measures to keep your information secure and limit access to it.
                No online service can guarantee absolute security, but we treat your family's data
                with care.
            </p>

            <h2>Sharing</h2>
            <p>
                We do <strong>not</strong> sell, rent or trade your information. We share it only
                with service providers strictly necessary to run the service (e.g. our payment
                processor and email/messaging tools), and where required by law.
            </p>

            <h2>Data retention</h2>
            <p>
                We keep your information for as long as needed to deliver the report and provide
                reasonable follow-up support, after which we retain or delete it in line with
                applicable law. You may request deletion of your data by emailing us.
            </p>

            <h2>Your choices</h2>
            <p>
                You can ask us to access, correct or delete your information at any time by
                writing to{" "}
                <a href="mailto:thecounselco@gmail.com">thecounselco@gmail.com</a>.
            </p>

            <h2>Children's privacy</h2>
            <p>
                The assessment is intended for students aged approximately 12–18 (Grades 7–12) and
                is purchased and consented to by a parent or guardian. We do not knowingly collect
                information directly from a child without parental consent.
            </p>

            <h2>Changes</h2>
            <p>
                We may update this policy; the latest version will always be posted here.
            </p>

            <h2>Contact</h2>
            <p>
                Questions about your privacy? Email{" "}
                <a href="mailto:thecounselco@gmail.com">thecounselco@gmail.com</a>.
            </p>
        </LegalShell>
    );
}
